// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Page Styling */
.page-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px;
    font-family: Arial, sans-serif;
    background-color: #f9f9f9;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
}

/* Section Headers */
.section-header {
    font-size: 24px;
    margin-bottom: 20px;
    color: #3d346e;
    border-bottom: 3px solid #ddd;
    padding-bottom: 8px;
}

/* Department Info Styling */
.department-info {
    margin-bottom: 20px;
    padding: 10px;
    background-color: #e8f4fa;
    border-left: 4px solid #287acc;
    border-radius: 5px;
}

.department-info h2,
.department-info h3 {
    color: #287acc;
    font-size: 18px;
    margin: 5px 0;
}

/* Upload Section Styling */
.upload-section {
    margin-bottom: 40px;
    padding: 15px;
    background-color: #ffffff;
    border: 1px solid #dedede;
    border-radius: 8px;
}

.upload-section p {
    font-size: 14px;
    color: #123b5f;
    margin-bottom: 10px;
    white-space: pre-wrap;
}

/* Custom Input Fields */
.custom-input {
    width: 100%;
    padding: 10px;
    margin-bottom: 10px;
    font-size: 14px;
    border: 1px solid #ced4da;
    border-radius: 5px;
    box-sizing: border-box;
}

.custom-textarea {
    width: 100%;
    min-height: 100px;
    padding: 10px;
    margin-bottom: 10px;
    font-size: 14px;
    border: 1px solid #ced4da;
    border-radius: 5px;
    box-sizing: border-box;
    resize: vertical;
}

/* Buttons */
.update-button,
.delete-button {
    display: inline-block;
    padding: 10px 15px; /* Standardized padding */
    font-size: 14px;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.update-button {
    background-color: #007bff;
}

.update-button:hover {
    background-color: #0056b3;
}

.delete-button {
    background-color: #dc3545;
    margin-left: 10px;
}

.delete-button:hover {
    background-color: #b02a37;
}

.update-button:disabled,
.delete-button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
}

/* Error Message Styling */
.error-message {
    color: #dc3545;
    font-size: 14px;
    margin-bottom: 20px;
}

/* Fixed Table Styling */
.table-container table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
    background-color: #ffffff;
}

.table-container th, 
.table-container td {
    padding: 10px;
    text-align: left;
    border: 1px solid #ddd;
    font-size: 14px;
    color: #333;
}

.table-container th {
    background-color: #f4f4f4; /* Fixed contrast issue */
    font-weight: bold;
    color: #333; /* Better contrast */
}

.table-container tr:hover {
    background-color: #f9f9f9;
}

/* Thumbnail Styling */
.table-container td img.thumbnail {
    width: 80px;
    height: auto;
    object-fit: cover;
    border-radius: 5px;
    display: block;
    margin: 0 auto;
}

/* Responsive Design */
@media (max-width: 768px) {
    .page-container {
        padding: 10px;
    }

    .section-header {
        font-size: 20px;
    }

    .custom-textarea,
    .custom-input {
        font-size: 13px;
    }

    .update-button,
    .delete-button {
        font-size: 13px;
        padding: 10px 12px; /* Consistent padding */
    }

    .table-container td img.thumbnail {
        width: 50px;
    }

    /* Added mobile table adjustments */
    .table-container th, 
    .table-container td {
        padding: 8px;
        font-size: 13px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/DepartmentDashboard.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA,oBAAoB;AACpB;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA,4BAA4B;AAC5B;IACI,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,aAAa;AACjB;;AAEA,2BAA2B;AAC3B;IACI,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA,wBAAwB;AACxB;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,YAAY;AACZ;;IAEI,qBAAqB;IACrB,kBAAkB,EAAE,yBAAyB;IAC7C,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA,0BAA0B;AAC1B;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA,wBAAwB;AACxB;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;;IAEI,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,yBAAyB,EAAE,yBAAyB;IACpD,iBAAiB;IACjB,WAAW,EAAE,oBAAoB;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,sBAAsB;AACtB;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,cAAc;AAClB;;AAEA,sBAAsB;AACtB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,eAAe;QACf,kBAAkB,EAAE,uBAAuB;IAC/C;;IAEA;QACI,WAAW;IACf;;IAEA,mCAAmC;IACnC;;QAEI,YAAY;QACZ,eAAe;IACnB;AACJ","sourcesContent":["/* General Page Styling */\r\n.page-container {\r\n    max-width: 1200px;\r\n    margin: 0 auto;\r\n    padding: 40px;\r\n    font-family: Arial, sans-serif;\r\n    background-color: #f9f9f9;\r\n    border: 1px solid #e0e0e0;\r\n    border-radius: 8px;\r\n}\r\n\r\n/* Section Headers */\r\n.section-header {\r\n    font-size: 24px;\r\n    margin-bottom: 20px;\r\n    color: #3d346e;\r\n    border-bottom: 3px solid #ddd;\r\n    padding-bottom: 8px;\r\n}\r\n\r\n/* Department Info Styling */\r\n.department-info {\r\n    margin-bottom: 20px;\r\n    padding: 10px;\r\n    background-color: #e8f4fa;\r\n    border-left: 4px solid #287acc;\r\n    border-radius: 5px;\r\n}\r\n\r\n.department-info h2,\r\n.department-info h3 {\r\n    color: #287acc;\r\n    font-size: 18px;\r\n    margin: 5px 0;\r\n}\r\n\r\n/* Upload Section Styling */\r\n.upload-section {\r\n    margin-bottom: 40px;\r\n    padding: 15px;\r\n    background-color: #ffffff;\r\n    border: 1px solid #dedede;\r\n    border-radius: 8px;\r\n}\r\n\r\n.upload-section p {\r\n    font-size: 14px;\r\n    color: #123b5f;\r\n    margin-bottom: 10px;\r\n    white-space: pre-wrap;\r\n}\r\n\r\n/* Custom Input Fields */\r\n.custom-input {\r\n    width: 100%;\r\n    padding: 10px;\r\n    margin-bottom: 10px;\r\n    font-size: 14px;\r\n    border: 1px solid #ced4da;\r\n    border-radius: 5px;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.custom-textarea {\r\n    width: 100%;\r\n    min-height: 100px;\r\n    padding: 10px;\r\n    margin-bottom: 10px;\r\n    font-size: 14px;\r\n    border: 1px solid #ced4da;\r\n    border-radius: 5px;\r\n    box-sizing: border-box;\r\n    resize: vertical;\r\n}\r\n\r\n/* Buttons */\r\n.update-button,\r\n.delete-button {\r\n    display: inline-block;\r\n    padding: 10px 15px; /* Standardized padding */\r\n    font-size: 14px;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n}\r\n\r\n.update-button {\r\n    background-color: #007bff;\r\n}\r\n\r\n.update-button:hover {\r\n    background-color: #0056b3;\r\n}\r\n\r\n.delete-button {\r\n    background-color: #dc3545;\r\n    margin-left: 10px;\r\n}\r\n\r\n.delete-button:hover {\r\n    background-color: #b02a37;\r\n}\r\n\r\n.update-button:disabled,\r\n.delete-button:disabled {\r\n    background-color: #6c757d;\r\n    cursor: not-allowed;\r\n}\r\n\r\n/* Error Message Styling */\r\n.error-message {\r\n    color: #dc3545;\r\n    font-size: 14px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n/* Fixed Table Styling */\r\n.table-container table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    margin-top: 20px;\r\n    background-color: #ffffff;\r\n}\r\n\r\n.table-container th, \r\n.table-container td {\r\n    padding: 10px;\r\n    text-align: left;\r\n    border: 1px solid #ddd;\r\n    font-size: 14px;\r\n    color: #333;\r\n}\r\n\r\n.table-container th {\r\n    background-color: #f4f4f4; /* Fixed contrast issue */\r\n    font-weight: bold;\r\n    color: #333; /* Better contrast */\r\n}\r\n\r\n.table-container tr:hover {\r\n    background-color: #f9f9f9;\r\n}\r\n\r\n/* Thumbnail Styling */\r\n.table-container td img.thumbnail {\r\n    width: 80px;\r\n    height: auto;\r\n    object-fit: cover;\r\n    border-radius: 5px;\r\n    display: block;\r\n    margin: 0 auto;\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n    .page-container {\r\n        padding: 10px;\r\n    }\r\n\r\n    .section-header {\r\n        font-size: 20px;\r\n    }\r\n\r\n    .custom-textarea,\r\n    .custom-input {\r\n        font-size: 13px;\r\n    }\r\n\r\n    .update-button,\r\n    .delete-button {\r\n        font-size: 13px;\r\n        padding: 10px 12px; /* Consistent padding */\r\n    }\r\n\r\n    .table-container td img.thumbnail {\r\n        width: 50px;\r\n    }\r\n\r\n    /* Added mobile table adjustments */\r\n    .table-container th, \r\n    .table-container td {\r\n        padding: 8px;\r\n        font-size: 13px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
